<template>
  <div>
    <div class="row mt-4">
      <div class="col">
        <div class="card custom-form__card">
          <div class="card-header d-flex justify-content-between">
            <h5>Treinamento para a Inteligência Artificial</h5>
          </div>
          <div class="card-body">
            <!-- Seletor de Treinamento -->
            <div class="form-group">
              <label style="font-weight: 600; font-size: 1.3rem;">Selecionar Treinamento Existente</label>
              <select
                class="form-control"
                v-model="selectedTrainingId"
                @change="carregarTreinamentoExistente(selectedTrainingId)"
              >
                <option disabled value="">Edite um treinamento existente...</option>
                <option value="__novo__" style="color: blue; font-weight: bold;">Criar novo treinamento</option>
                <option
                  v-for="t in treinamentosExistentes"
                  :key="t.id"
                  :value="t.id"
                >
                  {{ t.nome }}
                </option>
              </select>
            </div>



            <!-- Seletor de Nome do Treinamento -->
            <div class="form-group">
              <label style="font-weight: 600; font-size: 1.3rem;">Nome do Treinamento</label>
              <input
                type="text"
                class="form-control"
                v-model="form.nome"
                placeholder="Ex: Atendimento IA - Locação"
              />
            </div>

            <!-- XML de Treinamento -->
            <div class="form-group" v-if="isSuper">
              <label style="font-weight: 600; font-size: 1.3rem;">XML de Treinamento</label>
              <textarea class="form-control" v-model="form.training" rows="6"></textarea>
            </div>

            <!-- Modelo e Temperatura -->
            <div class="form-row" v-if="isSuper">
              <div class="form-group col-md-6">
                <label style="font-weight: 600; font-size: 1.3rem;">Modelo</label>
                <select class="form-control" v-model="form.model">
                <option v-for="model in modelosDisponiveis" :key="model.id" :value="model.id">
                  {{ model.id }}
                </option>
                </select>
                <div v-if="form.model" class="mt-2">
                  <small class="text-muted">Modelo selecionado: {{ form.model }}</small>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label style="font-weight: 600; font-size: 1.3rem;">Temperatura</label>
                <select class="form-control" v-model="form.temperature">
                  <option v-for="temp in temperaturas" :key="temp" :value="parseFloat(temp)">{{ temp }}</option>
                </select>
              </div>
            </div>

            <!-- Ferramentas -->
            <div class="form-group">
              <label class="mb-2" style="font-weight: 600; font-size: 1.3rem;">Ferramentas Disponíveis</label>
              <div class="row">
                <div
                  v-for="(info, key) in toolsDisponiveis"
                  :key="key"
                  class="col-md-4 mb-2"
                >
                  <div class="d-flex align-items-start h-100">
                    <div v-if="key === 'redirecionar_outros_assuntos'" class="d-flex flex-column w-100">
                      <div class="d-flex justify-content-between align-items-center">
                        <Check
                          v-model="form.tools"
                          :optionValue="key"
                          :description="''"
                          @change="checkRedirecionamentoSelecionado(key)"
                        >
                          {{ info.nome }}
                        </Check>

                        <button
                          v-if="redirecionamentoAtivo"
                          class="btn btn-xs btn-outline-primary ml-2 py-1 px-2"
                          style="font-size: 0.75rem; line-height: 1.2;"
                          @click="mostrarModalRedirecionamento = true"
                        >
                          Configurar
                        </button>
                      </div>
                      <small class="text-muted">{{ info.descricao }}</small>
                    </div>

                    <!-- versão normal para os demais -->
                    <div v-else>
                      <Check
                        v-model="form.tools"
                        :optionValue="key"
                        :description="info.descricao"
                        @change="checkRedirecionamentoSelecionado(key)"
                      >
                        {{ info.nome }}
                      </Check>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- Fases e Atendentes -->
            <div class="form-row">
              <!-- === Fase ao finalizar locação === -->
              <div class="form-group col-12">
                <label style="font-weight: 600; font-size: 1.3rem;">Fase ao finalizar locação</label>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Pipeline</label>
                    <select class="form-control" v-model="form.pipelineWhenToEndLease" @change="loadFases('endLease')">
                      <option value="" disabled>Selecione</option>
                      <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Fase</label>
                    <select
                      class="form-control"
                      v-model="form.phaseWhenToEndLease"
                      :disabled="fases.endLease.length === 0"
                    >
                      <option value="" disabled>Selecione</option>
                      <option v-for="f in fases.endLease" :key="f.id" :value="f.id">{{ f.nome }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- === Fase ao gerar orçamento === -->
              <div class="form-group col-12">
                <label style="font-weight: 600; font-size: 1.3rem;">Fase ao gerar orçamento</label>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Pipeline</label>
                    <select class="form-control" v-model="form.pipelineWhenGenerateBudget" @change="loadFases('generateBudget')">
                      <option value="" disabled>Selecione</option>
                      <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Fase</label>
                    <select
                      class="form-control"
                      v-model="form.phaseWhenGenerateBudget"
                      :disabled="fases.generateBudget.length === 0"
                    >
                      <option value="" disabled>Selecione</option>
                      <option v-for="f in fases.generateBudget" :key="f.id" :value="f.id">{{ f.nome }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- === Fase quando offline === -->
              <div class="form-group col-12">
                <label style="font-weight: 600; font-size: 1.3rem;">Fase quando o cliente ficar offline</label>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Pipeline</label>
                    <select class="form-control" v-model="form.pipelineWhenOffline" @change="loadFases('offline')">
                      <option value="" disabled>Selecione</option>
                      <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Fase</label>
                    <select
                      class="form-control"
                      v-model="form.offlinePhase"
                      :disabled="fases.offline.length === 0"
                    >
                      <option value="" disabled>Selecione</option>
                      <option v-for="f in fases.offline" :key="f.id" :value="f.id">{{ f.nome }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- === Fase ao pedir humano === -->
              <div class="form-group col-12">
                <label style="font-weight: 600; font-size: 1.3rem;">Fase quando cliente quiser falar com um consultor</label>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Pipeline</label>
                    <select class="form-control" v-model="form.pipelineWhenWantsAttendant" @change="loadFases('human')">
                      <option value="" disabled>Selecione</option>
                      <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Fase</label>
                    <select
                      class="form-control"
                      v-model="form.phaseWhenWantsAttendant"
                      :disabled="fases.human.length === 0"
                    >
                      <option value="" disabled>Selecione</option>
                      <option v-for="f in fases.human" :key="f.id" :value="f.id">{{ f.nome }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- === Atendentes === -->
              <div class="form-group col-md-6">
                <label style="font-weight: 600; font-size: 1.3rem;">Atendente quando for finalizada a locação</label>
                <select class="form-control" v-model="form.attendantWhenEndLease">
                  <option disabled value="">Selecione um atendente</option>
                  <option :value="null">– Nenhum atendente –</option>
                  <option v-for="u in usuarios" :key="u.id" :value="u.id">
                    {{ u.name }} ({{ u.email }})
                  </option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label style="font-weight: 600; font-size: 1.3rem;">Atendente ao gerar orçamento</label>
                <select class="form-control" v-model="form.attendantWhenGenerateBudget">
                  <option disabled value="">Selecione um atendente</option>
                  <option :value="null">– Nenhum atendente –</option>
                  <option v-for="u in usuarios" :key="u.id" :value="u.id">
                    {{ u.name }} ({{ u.email }})
                  </option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label style="font-weight: 600; font-size: 1.3rem;">Atendente quando o cliente ficar offline</label>
                <select class="form-control" v-model="form.attendantWhenOffline">
                  <option disabled value="">Selecione um atendente</option>
                  <option :value="null">– Nenhum atendente –</option>
                  <option v-for="u in usuarios" :key="u.id" :value="u.id">
                    {{ u.name }} ({{ u.email }})
                  </option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label style="font-weight: 600; font-size: 1.3rem;">Atendente quando cliente quiser falar com um consultor</label>
                <select class="form-control" v-model="form.wantsAttendant">
                  <option disabled value="">Selecione um atendente</option>
                  <option :value="null">– Nenhum atendente –</option>
                  <option v-for="u in usuarios" :key="u.id" :value="u.id">
                    {{ u.name }} ({{ u.email }})
                  </option>
                </select>
              </div>
            </div>

            <!-- Ações Customizadas -->
            <div class="form-group">
              <label style="font-weight: 600; font-size: 1.3rem;">Ações Customizadas</label>
              <div class="row">
                <div class="col-md-4 mb-2">
                  <div class="d-flex align-items-start h-100">
                    <Check
                      v-model="form.sendProductPrice"
                      description="Envia o preço do produto diretamente para o cliente."
                    >
                      Enviar Preço do Produto
                    </Check>
                  </div>
                </div>

                <div class="col-md-4 mb-2 d-flex align-items-stretch">
                  <Check
                    v-model="form.sendImageInListing"
                    description="Envia imagem dos produtos na listagem para o cliente."
                  >
                    Enviar imagem
                  </Check>
                </div>
              </div>
            </div>

            <!-- Exibição dos Equipamentos -->
            <div class="form-group">
              <label style="font-weight: 600; font-size: 1.3rem;">Exibição dos Equipamentos</label>
              <select class="form-control" v-model.number="form.displayExibition">
                <option v-for="opt in displayOptions" :key="opt.id" :value="opt.id">
                  {{ opt.label }}
                </option>
              </select>
              <small class="text-muted d-block mt-1">
                Define de onde a IA buscará os equipamentos, Loja, CRM ou ambos.
              </small>
            </div>

            <!-- Cobrança por Tempo de Chat -->
            <div class="form-group">
              <label style="font-weight: 600; font-size: 1.3rem;">Cobrança por Tempo de Chat</label>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Intervalo entre cobranças (segundos)</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="form.chargeChatTime"
                    min="0"
                    step="1"
                    placeholder="Ex.: 60"
                  />
                  <small class="text-muted">Tempo mínimo entre uma cobrança e outra.</small>
                </div>
                <div class="form-group col-md-6">
                  <label>Tentativas consecutivas de cobrança</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="form.chargeChatRetrys"
                    min="0"
                    step="1"
                    placeholder="Ex.: 2"
                  />
                  <small class="text-muted">Quantas vezes cobrar em sequência antes de parar.</small>
                </div>
              </div>
            </div>

            <!-- Proteção -->
            <div class="form-group">
              <label style="font-weight: 600; font-size: 1.3rem;">Comportamento de Proteção</label>
              <select class="form-control" v-model="form.sendTypeProtection">
                <option value="NON_BUILT_IN_PROTECTION">Não informar proteção</option>
                <option value="BUILT_IN_WITH_PRICE">Proteção embutida no preço</option>
                <option value="BUILT_IN_SEPARATE">Proteção separada</option>
              </select>
            </div>

            <!-- Botão Salvar -->
            <div class="form-group mt-4 text-right">
              <button
                v-if="selectedTrainingId"
                class="btn btn-success btn-sm mr-2"
                @click="atualizarTreinamento"
              >
                <i class="fa fa-save mr-1"></i> Atualizar Treinamento
              </button>

              <button
                v-else
                class="btn btn-success btn-sm mr-2"
                @click="salvarTreinamento"
              >
                <i class="fa fa-save mr-1"></i> Salvar Treinamento
              </button>

              <button
                v-if="selectedTrainingId"
                class="btn btn-danger btn-sm"
                data-toggle="modal"
                data-target="#modalConfirmarDelecao"
              >
                <i class="fa fa-trash mr-1"></i> Deletar Treinamento
              </button>
            </div>
          </div>

          <!-- Modal Redirecionar Outros Assuntos -->
          <div v-if="mostrarModalRedirecionamento" class="custom-modal-overlay">
            <div class="custom-modal window.theme">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="m-0">Configurar Redirecionamento de Outros Assuntos</h5>
                <button class="btn btn-sm btn-danger" @click="mostrarModalRedirecionamento = false">&times;</button>
              </div>

              <div class="form-group">
                <label>Pipeline</label>
                <select class="form-control" v-model="novoRedirecionamento.pipelineId" @change="loadFases('redirect')">
                  <option value="" disabled>Selecione</option>
                  <option v-for="p in pipelinesAtendente" :key="p.id" :value="p.id">{{ p.value }}</option>
                </select>
              </div>

              <div class="form-group">
                <label>Fase</label>
                <select class="form-control" v-model="novoRedirecionamento.faseId" :disabled="fases.redirect.length === 0">
                  <option value="" disabled>Selecione</option>
                  <option v-for="f in fases.redirect" :key="f.id" :value="f.id">{{ f.nome }}</option>
                </select>
              </div>

              <div class="form-group">
                <label>Atendente (opcional)</label>
                <select class="form-control" v-model="novoRedirecionamento.atendenteId" @change="novoRedirecionamento.userId = novoRedirecionamento.atendenteId">
                  <option value="">Selecione</option>
                  <option v-for="u in usuarios" :key="u.id" :value="u.id">{{ u.name }}</option>
                </select>
              </div>

              <div class="form-group">
                <label>Descrição</label>
                <input class="form-control" v-model="novoRedirecionamento.descricao" placeholder="Breve explicação..." />
              </div>

              <div class="text-right mb-3">
                <button class="btn btn-primary btn-sm" @click="adicionarRedirecionamento">Adicionar</button>
              </div>

              <div v-if="form.redirecionamentos.length > 0">
                <h6>Redirecionamentos Adicionados:</h6>
                <ul class="list-group">
                  <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(r, idx) in form.redirecionamentos" :key="idx">
                    <div>
                      <strong>Pipeline:</strong> {{ nomePipeline(r.pipelineId) }} |
                      <strong>Fase:</strong> {{ nomeFase('redirect', r.faseId, r.pipelineId) }}<br>
                      <span v-if="r.userId || r.atendenteId">
                        <strong>Atendente:</strong> {{ nomeAtendente(r.userId ?? r.atendenteId) }}<br>
                      </span>
                      <small class="text-muted">{{ r.descricao }}</small>
                    </div>
                    <button class="btn btn-sm btn-outline-danger" @click="removerRedirecionamento(idx)">Remover</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Modal de confirmação de deleção -->
          <div
            class="modal fade"
            id="modalConfirmarDelecao"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modalLabelDeletar"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header bg-danger">
                  <h5 class="modal-title" id="modalLabelDeletar">Confirmar Deleção</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  Tem certeza que deseja <strong>deletar permanentemente</strong> este treinamento?
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
                    Cancelar
                  </button>
                  <button type="button" class="btn btn-danger btn-sm" @click="confirmarDelecao">
                    <i class="fa fa-trash mr-1"></i> Confirmar Deleção
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Check from '../ui/Check.vue';

export default {
  components: {
    Check
  },
  mounted() {
    document.getElementById('overlayer-loading')?.classList.add('show-overlayer');

    document.body.setAttribute('data-theme', window.theme || 'light');

    Promise.all([
      this.getOpenAIModels(),
      this.getPipelinesAtendente(),
      this.getUsuarios(),
      this.getTreinamentos()
    ]).finally(() => {
      document.getElementById('overlayer-loading')?.classList.remove('show-overlayer');
    });
  },
  data() {
    return {
      displayOptions: [
        { id: 0, label: 'Exibir na Loja e no CRM (AMBOS)' },
        { id: 1, label: 'Exibir somente na Loja' },
        { id: 2, label: 'Exibir somente no CRM' },
      ],
      todasFases: {},
      modoEdicao: false,
      usuarios: [],
      pipelinesAtendente: [],
      fases: {
        endLease: [],
        generateBudget: [],
        offline: [],
        human: [],
        redirect: []
      },
      selectedTrainingId: '',
      modelosDisponiveis: [],
      temperaturas: Array.from({ length: 10 }, (_, i) => (0.1 * (i + 1)).toFixed(1)),
      toolsDisponiveis: {
        buscar_equipamento: {
          nome: 'Buscar Equipamento',
          descricao: 'Buscar equipamento desejado pelo cliente nos produtos da Loja.'
        },
        busca_data_dia: {
          nome: 'Busca Data/Dia',
          descricao: 'Identifica e interpreta datas mencionadas pelo cliente durante a conversa.'
        },
        finalizar_locacao: {
          nome: 'Finalizar Locação',
          descricao: 'Permite que a IA conclua automaticamente uma locação quando possível.'
        },
        gerar_orcamento: {
          nome: 'Gerar Orçamento',
          descricao: 'Cria automaticamente um orçamento quando o cliente confirma interesse no equipamento.'
        },
        transferir_para_humano: {
          nome: 'Transferir para Humano',
          descricao: 'Encaminha o atendimento para um operador humano quando solicitado ou necessário.'
        },
        calcular_entrega: {
          nome: 'Calcular Entrega',
          descricao: 'Calcula frete e condições para entrega dos equipamentos.'
        },
        pegar_link_online: {
          nome: 'Pegar Link Online',
          descricao: 'Gera e envia um link para atendimento online ou acompanhamento da locação.'
        },
        redirecionar_outros_assuntos: {
          nome: 'Redirecionar Outros Assuntos',
          descricao: 'Redireciona temas fora do escopo da IA para os setores adequados.'
        },
        enviar_foto_equipamento: {
          nome: 'Enviar Foto do Equipamento',
          descricao: 'Envia ao cliente a imagem do equipamento cotado ou sugerido.'
        },
        locacao_andaime: {
          nome: 'Locação de Andaime',
          descricao: 'Aplica regras específicas para locação de andaimes, como metragem e tipos.'
        }
      },
      treinamentosExistentes: [],
      mostrarModalRedirecionamento: false,
      novoRedirecionamento: {
        pipelineId: '',
        faseId: '',
        descricao: '',
        atendenteId: '',
        userId: ''
      },
      mostrarHorarioFuncionamento: false,
      diasAtivos: ['segunda', 'terca', 'quarta', 'quinta', 'sexta'],
      form: {
        nome: '',
        redirecionamentos: [],
        tools: [],
        localizacao: '',
        horarioFuncionamento: {
          segunda: { inicio: '', fim: '' },
          terca: { inicio: '', fim: '' },
          quarta: { inicio: '', fim: '' },
          quinta: { inicio: '', fim: '' },
          sexta: { inicio: '', fim: '' },
          sabado: { inicio: '', fim: '' },
          domingo: { inicio: '', fim: '' }
        },
        training: '',
        model: 'gpt-4.1-mini-2025-04-14',
        temperature: 0.2,
        tools: [],
        phaseWhenToEndLease: '',
        chargesCount: 2,
        offlinePhase: '',
        attendantWhenOffline: '',
        attendantWhenEndLease: '',
        attendantWhenGenerateBudget: '',
        wantsAttendant: '',
        phaseWhenWantsAttendant: '',
        phaseWhenGenerateBudget: '',
        pipelineWhenToEndLease: '',
        pipelineWhenOffline: '',
        pipelineWhenWantsAttendant: '',
        pipelineWhenGenerateBudget: '',
        nichoId: '',
        templateId: '',
        sendEcommerceLink: false,
        sendProductPrice: true,
        sendImageInListing: false,
        sendTypeProtection: 'NON_BUILT_IN_PROTECTION',
        displayExibition: 0,
        chargeChatTime: 0,
        chargeChatRetrys: 1
      }
    }
  },
  computed: {
    isSuper() {
      return window.super == 1;
    },
    nomeAttendenteFinal() {
      const found = this.usuarios.find(u => u.id === this.form.attendantWhenEndLease);
      return found ? found.name : '';
    },
    redirecionamentoAtivo() {
      return this.form.tools.includes('redirecionar_outros_assuntos');
    }
  },
  watch: {
    selectedTrainingId(newVal) {
      if (newVal) {
        this.carregarTreinamentoExistente(newVal);
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        nome: '',
        redirecionamentos: [],
        tools: [],
        localizacao: '',
        horarioFuncionamento: {
          segunda: { inicio: '', fim: '' },
          terca: { inicio: '', fim: '' },
          quarta: { inicio: '', fim: '' },
          quinta: { inicio: '', fim: '' },
          sexta: { inicio: '', fim: '' },
          sabado: { inicio: '', fim: '' },
          domingo: { inicio: '', fim: '' }
        },
        training: '',
        model: 'gpt-4.1-mini-2025-04-14',
        temperature: 0.2,
        phaseWhenToEndLease: '',
        chargesCount: 2,
        offlinePhase: '',
        attendantWhenOffline: '',
        attendantWhenEndLease: '',
        attendantWhenGenerateBudget: '',
        wantsAttendant: '',
        phaseWhenWantsAttendant: '',
        phaseWhenGenerateBudget: '',
        pipelineWhenToEndLease: '',
        pipelineWhenOffline: '',
        pipelineWhenWantsAttendant: '',
        pipelineWhenGenerateBudget: '',
        nichoId: '',
        templateId: '',
        sendEcommerceLink: false,
        sendProductPrice: true,
        sendImageInListing: false,
        sendTypeProtection: 'NON_BUILT_IN_PROTECTION',
        displayExibition: 0,
        chargeChatTime: 0,
        chargeChatRetrys: 1
      };

      this.mostrarModalRedirecionamento = false;
      this.novoRedirecionamento = { pipelineId: '', faseId: '', descricao: '', atendenteId: '', userId: '' };

      this.fases = {
        endLease: [],
        offline: [],
        human: [],
        redirect: []
      };
    },
    async carregarFasesRedirecionamentos() {
      const promessas = [];

      for (const r of this.form.redirecionamentos) {
        const pipelineId = r.pipelineId;
        if (pipelineId && !this.todasFases[pipelineId]) {
          promessas.push(
            api.get(`/painel/oportunidades-pipelines/listar-fases/${pipelineId}`)
              .then(response => {
                const fasesFormatadas = Array.isArray(response.data.fases)
                  ? response.data.fases.map(f => ({ id: f.id, nome: f.value }))
                  : [];
                this.todasFases[pipelineId] = fasesFormatadas;
              })
              .catch(error => {
                console.warn(`Erro ao carregar fases para pipeline ${pipelineId}`, error);
              })
          );
        }
      }

      await Promise.all(promessas);
    },
    async atualizarTreinamento() {
      const loader = document.getElementById('overlayer-loading');
      loader?.classList.add('show-overlayer');

      try {
        const id = this.selectedTrainingId;
        if (!id) throw new Error('Treinamento não selecionado.');

        const payload = {
          nome: this.form.nome,
          xml: this.form.training,
          modelo: this.form.model,
          temperatura: this.form.temperature,
          loja_id: window.lojaId,
          user_id: window.userId,
          buscar_equipamento: this.form.tools.includes('buscar_equipamento'),
          transferir_para_humano: this.form.tools.includes('transferir_para_humano'),
          buscar_data: this.form.tools.includes('busca_data_dia'),
          calculo_de_frete: this.form.tools.includes('calcular_entrega'),
          enviar_foto_equipamento: this.form.tools.includes('enviar_foto_equipamento'),
          finalizar_locacao: this.form.tools.includes('finalizar_locacao'),
          pegar_link_online: this.form.tools.includes('pegar_link_online'),
          locacao_andaime: this.form.tools.includes('locacao_andaime'),
          gerar_orcamento: this.form.tools.includes('gerar_orcamento'),
          redirecionar_outros_assuntos: this.form.redirecionamentos,
          finalizar_locacao_info: {
            pipelineId: this.form.pipelineWhenToEndLease || null,
            faseId: this.form.phaseWhenToEndLease || null
          },
          gerar_orcamento_info: {
            pipelineId: this.form.pipelineWhenGenerateBudget || null,
            faseId: this.form.phaseWhenGenerateBudget || null
          },
          cliente_offline_info: {
            pipelineId: this.form.pipelineWhenOffline || null,
            faseId: this.form.offlinePhase || null
          },
          transferir_para_humano_info: {
            pipelineId: this.form.pipelineWhenWantsAttendant || null,
            faseId: this.form.phaseWhenWantsAttendant || null
          },
          atendente_finalizar_locacao: this.form.attendantWhenEndLease || null,
          atendente_gerar_orcamento: this.form.attendantWhenGenerateBudget || null,
          atendente_cliente_offline: this.form.attendantWhenOffline || null,
          atendente_transferir_para_humano: this.form.wantsAttendant || null,
          enviar_preco_produto: this.form.sendProductPrice,
          enviar_imagem_na_listagem: this.form.sendImageInListing,
          protecao: this.mapProtecao(this.form.sendTypeProtection),
          display_exibition: Number(this.form.displayExibition),
          charge_chat_time: Number(this.form.chargeChatTime),
          charge_chat_retrys: Number(this.form.chargeChatRetrys),
        };

        const response = await api.patch(`/painel/ia/treinamento/${id}`, payload);
        const treinamentoAtualizado = response.data?.treinamento;

        const idx = this.treinamentosExistentes.findIndex(t => t.id === id);
        if (idx !== -1) {
          this.treinamentosExistentes.splice(idx, 1, treinamentoAtualizado);
        } else {
          this.treinamentosExistentes.push(treinamentoAtualizado);
        }

        this.selectedTrainingId = treinamentoAtualizado.id;

        window.showToastSuccess?.('body', 'Treinamento atualizado com sucesso!');
      } catch (e) {
        const mensagem =
          e?.response?.data?.message ||
          e?.response?.data?.errors?.[Object.keys(e.response.data.errors)[0]]?.[0] ||
          'Erro ao atualizar treinamento.';

        window.showToastDanger?.('body', mensagem);
      } finally {
        loader?.classList.remove('show-overlayer');
      }
    },
    async confirmarDelecao() {
      const loader = document.getElementById('overlayer-loading');
      loader?.classList.add('show-overlayer');

      try {
        const id = this.selectedTrainingId;
        if (!id) {
          window.showToastDanger?.('body', 'Nenhum treinamento selecionado.');
          return;
        }

        await api.delete(`/painel/ia/treinamento/${id}`);

        window.showToastSuccess?.('body', 'Treinamento deletado com sucesso!');
        
        // Remove o treinamento da lista local em vez de recarregar tudo
        const idx = this.treinamentosExistentes.findIndex(t => t.id === id);
        if (idx !== -1) {
          this.treinamentosExistentes.splice(idx, 1);
        }
        
        this.selectedTrainingId = '';
        this.resetForm();
      } catch (e) {
        const mensagem =
          e?.response?.data?.message ||
          e?.response?.data?.errors?.[Object.keys(e.response?.data?.errors || {})[0]]?.[0] ||
          'Erro ao deletar treinamento.';

        window.showToastDanger?.('body', mensagem);
      } finally {
        loader?.classList.remove('show-overlayer');
        $('#modalConfirmarDelecao').modal('hide');
      }
    },
    reverseProtecao(valor) {
      switch (valor) {
        case 1: return 'BUILT_IN_WITH_PRICE';
        case 2: return 'BUILT_IN_SEPARATE';
        default: return 'NON_BUILT_IN_PROTECTION';
      }
    },
    async carregarTreinamentoExistente(id) {
      if (id === '__novo__') {
        this.selectedTrainingId = '';
        this.resetForm();
        return;
      }

      const loader = document.getElementById('overlayer-loading');
      loader?.classList.add('show-overlayer');

      try {
        const response = await api.get(`/painel/ia/treinamento/${id}`);
        const data = response.data;

        this.form.nome = data.nome || '';
        this.form.training = data.xml || '';
        this.form.model = data.modelo || '';
        this.form.temperature = data.temperatura || 0.2;

        this.form.tools = [
          ...(data.buscar_equipamento ? ['buscar_equipamento'] : []),
          ...(data.transferir_para_humano ? ['transferir_para_humano'] : []),
          ...(data.buscar_data ? ['busca_data_dia'] : []),
          ...(data.calculo_de_frete ? ['calcular_entrega'] : []),
          ...(data.enviar_foto_equipamento ? ['enviar_foto_equipamento'] : []),
          ...(data.finalizar_locacao ? ['finalizar_locacao'] : []),
          ...(data.pegar_link_online ? ['pegar_link_online'] : []),
          ...(data.locacao_andaime ? ['locacao_andaime'] : []),
          ...(data.gerar_orcamento ? ['gerar_orcamento'] : []),
          ...(Array.isArray(data.redirecionar_outros_assuntos) && data.redirecionar_outros_assuntos.length > 0 ? ['redirecionar_outros_assuntos'] : [])
        ];

        this.form.pipelineWhenToEndLease = data.finalizar_locacao_info?.pipelineId || '';
        this.form.phaseWhenToEndLease = data.finalizar_locacao_info?.faseId || '';

        this.form.pipelineWhenGenerateBudget = data.gerar_orcamento_info?.pipelineId || '';
        this.form.phaseWhenGenerateBudget = data.gerar_orcamento_info?.faseId || '';

        this.form.pipelineWhenOffline = data.cliente_offline_info?.pipelineId || '';
        this.form.offlinePhase = data.cliente_offline_info?.faseId || '';

        this.form.pipelineWhenWantsAttendant = data.transferir_para_humano_info?.pipelineId || '';
        this.form.phaseWhenWantsAttendant = data.transferir_para_humano_info?.faseId || '';

        this.form.attendantWhenEndLease = data.atendente_finalizar_locacao || '';
        this.form.attendantWhenGenerateBudget = data.atendente_gerar_orcamento || '';
        this.form.attendantWhenOffline = data.atendente_cliente_offline || '';
        this.form.wantsAttendant = data.atendente_transferir_para_humano || '';

        this.form.sendProductPrice = data.enviar_preco_produto || false;
        this.form.sendImageInListing = data.enviar_imagem_na_listagem || false;
        this.form.sendTypeProtection = this.reverseProtecao(data.protecao);

        this.form.redirecionamentos = Array.isArray(data.redirecionar_outros_assuntos)
          ? data.redirecionar_outros_assuntos.map(item => {
            const usuario = item.userId ?? item.atendenteId ?? item.user_id ?? '';
            const usuarioString = usuario === null ? '' : String(usuario);

            return {
              pipelineId: item.pipelineId ?? '',
              faseId: item.faseId ?? '',
              descricao: item.descricao ?? '',
              atendenteId: usuarioString,
              userId: usuarioString
            };
          })
          : [];

        this.form.displayExibition = Number(data.display_exibition ?? 0);
        this.form.chargeChatTime   = Number(data.charge_chat_time ?? 0);
        this.form.chargeChatRetrys = Number(data.charge_chat_retrys ?? 1);
        
        // Carregar todas as fases em paralelo para melhor performance
        const promises = [
          this.loadFases('endLease'),
          this.loadFases('generateBudget'),
          this.loadFases('offline'),
          this.loadFases('human')
        ];

        if (this.form.redirecionamentos.length > 0) {
          promises.push(this.carregarFasesRedirecionamentos());
        }

        await Promise.all(promises);

        this.modoEdicao = true;
      } catch (e) {
        window.showToastDanger?.('body', 'Erro ao carregar dados do treinamento.');
      } finally {
        loader?.classList.remove('show-overlayer');
      }
    },
    async getTreinamentos() {
      try {
        if (!window.lojaId) {
          this.treinamentosExistentes = [];
        } else {
          const response = await api.get('/painel/ia/treinamentos', {
            params: { lojaId: window.lojaId }
          });
  
          this.treinamentosExistentes = response.data || [];
        }
      } catch (e) {
        window.showToastDanger?.('body', 'Erro ao carregar treinamentos.');
      }
    },
    async salvarTreinamento() {
      const loader = document.getElementById('overlayer-loading');
      loader?.classList.add('show-overlayer');

      try {
        const payload = {
          nome: this.form.nome,
          xml: this.form.training,
          modelo: this.form.model,
          temperatura: this.form.temperature,
          loja_id: window.lojaId,
          user_id: window.userId,

          // ferramentas
          buscar_equipamento: this.form.tools.includes('buscar_equipamento'),
          transferir_para_humano: this.form.tools.includes('transferir_para_humano'),
          buscar_data: this.form.tools.includes('busca_data_dia'),
          calculo_de_frete: this.form.tools.includes('calcular_entrega'),
          enviar_foto_equipamento: this.form.tools.includes('enviar_foto_equipamento'),
          finalizar_locacao: this.form.tools.includes('finalizar_locacao'),
          pegar_link_online: this.form.tools.includes('pegar_link_online'),
          locacao_andaime: this.form.tools.includes('locacao_andaime'),
          gerar_orcamento: this.form.tools.includes('gerar_orcamento'),

          // fases com pipeline
          finalizar_locacao_info: {
            pipelineId: this.form.pipelineWhenToEndLease || null,
            faseId: this.form.phaseWhenToEndLease || null,
          },
          gerar_orcamento_info: {
            pipelineId: this.form.pipelineWhenGenerateBudget || null,
            faseId: this.form.phaseWhenGenerateBudget || null,
          },
          cliente_offline_info: {
            pipelineId: this.form.pipelineWhenOffline || null,
            faseId: this.form.offlinePhase || null,
          },
          transferir_para_humano_info: {
            pipelineId: this.form.pipelineWhenWantsAttendant || null,
            faseId: this.form.phaseWhenWantsAttendant || null,
          },

          // atendentes
          atendente_finalizar_locacao: this.form.attendantWhenEndLease || null,
          atendente_gerar_orcamento: this.form.attendantWhenGenerateBudget || null,
          atendente_transferir_para_humano: this.form.wantsAttendant || null,
          atendente_cliente_offline: this.form.attendantWhenOffline || null,

          // ações extra
          enviar_preco_produto: this.form.sendProductPrice,
          enviar_imagem_na_listagem: this.form.sendImageInListing,

          // redirecionamento
          redirecionar_outros_assuntos: this.form.redirecionamentos,

          // proteção
          protecao: this.mapProtecao(this.form.sendTypeProtection),
          
          // display de equipamentos
          display_exibition: Number(this.form.displayExibition),
          charge_chat_time: Number(this.form.chargeChatTime),
          charge_chat_retrys: Number(this.form.chargeChatRetrys)
        };

        const response = await api.post('/painel/ia/treinamento', payload);
        const novoTreinamento = response.data?.treinamento;

        if (!novoTreinamento || !novoTreinamento.id) {
          throw new Error('Treinamento criado, mas sem ID retornado.');
        }

        this.treinamentosExistentes.push(novoTreinamento);
        this.selectedTrainingId = novoTreinamento.id;

        // Não precisa recarregar, já temos os dados do treinamento criado
        window.showToastSuccess?.('body', 'Treinamento criado com sucesso!');
      } catch (e) {
        window.showToastDanger?.('body', 'Erro ao salvar treinamento.');
      } finally {
        loader?.classList.remove('show-overlayer');
      }
    },
    mapProtecao(tipo) {
      switch (tipo) {
        case 'BUILT_IN_WITH_PRICE': return 1;
        case 'BUILT_IN_SEPARATE': return 2;
        default: return 0;
      }
    },
    checkRedirecionamentoSelecionado(key) {
      if (key === 'redirecionar_outros_assuntos' && this.form.tools.includes('redirecionar_outros_assuntos')) {
        this.mostrarModalRedirecionamento = true;
      }
    },
    abrirModalRedirecionar(valor) {
      if (valor && !this.mostrarModalRedirecionamento) {
        this.mostrarModalRedirecionamento = true;
      }
    },
    adicionarRedirecionamento() {
      const { pipelineId, faseId, descricao, atendenteId, userId } = this.novoRedirecionamento;
      if (pipelineId && faseId && descricao.trim()) {
        const usuarioSelecionado = atendenteId || userId || '';
        this.form.redirecionamentos.push({
          pipelineId,
          faseId,
          descricao,
          atendenteId: usuarioSelecionado,
          userId: usuarioSelecionado
        });
        this.novoRedirecionamento = { pipelineId: '', faseId: '', descricao: '', atendenteId: '', userId: '' };
        this.fases.redirect = [];
      } else {
        alert('Preencha todos os campos para adicionar.');
      }
    },
    removerRedirecionamento(idx) {
      this.form.redirecionamentos.splice(idx, 1);
    },
    nomePipeline(id) {
      const p = this.pipelinesAtendente.find(p => p.id === id);
      return p ? p.value : id;
    },
    nomeAtendente(id) {
      if (!id) return '';
      const idNormalizado = String(id);
      const usuario = this.usuarios.find(u => String(u.id) === idNormalizado);
      return usuario ? usuario.name : id;
    },
    nomeFase(tipo, faseId, pipelineIdManual = null) {
      let pipelineId = pipelineIdManual;

      if (!pipelineId) {
        const map = {
          endLease: 'pipelineWhenToEndLease',
          offline: 'pipelineWhenOffline',
          human: 'pipelineWhenWantsAttendant',
        };
        pipelineId = this.form[map[tipo]];
      }

      const fases = this.todasFases[pipelineId] || this.fases[tipo] || [];
      const fase = fases.find(f => f.id === faseId);
      return fase ? fase.nome : faseId;
    },
    handleHorarioChange(dia) {
      const h = this.form.horarioFuncionamento[dia];
      if (!h.ativo) {
        h.inicio = '';
        h.fim = '';
      }
    },
    handleHorarioToggle(dia) {
      const ativo = this.diasAtivos.includes(dia);
      if (!ativo) {
        this.form.horarioFuncionamento[dia].inicio = '';
        this.form.horarioFuncionamento[dia].fim = '';
      }
    },
    async getUsuarios() {
      try {
        const response = await api.get('/painel/usuarios',
          {
            params: {
              data: 1
            }
          }
        );

        this.usuarios = response.data;
      } catch (e) {
        console.error('Erro ao buscar usuários:', e);
      }
    },
    async getPipelinesAtendente() {
      try {
        const userId = window.userId;
        if (!userId) return;
        
        const response = await api.get(`/painel/oportunidades-pipelines`,
          {
            params: {
              data: 1
            }
          }
        );

        this.pipelinesAtendente = response.data;
      } catch (e) {
        console.error('Erro ao buscar pipelines do atendente:', e);
      }
    },
    async loadFases(tipo) {
      const pipelineKeyMap = {
        endLease: 'pipelineWhenToEndLease',
        generateBudget: 'pipelineWhenGenerateBudget',
        offline: 'pipelineWhenOffline',
        human: 'pipelineWhenWantsAttendant'
      };

      let pipelineId = '';

      if (tipo === 'redirect') {
        pipelineId = this.novoRedirecionamento.pipelineId;
      } else {
        pipelineId = this.form[pipelineKeyMap[tipo]];
      }

      const loader = document.getElementById('overlayer-loading');

      if (!pipelineId) {
        this.fases[tipo] = [];
        return;
      }

      try {
        loader?.classList.add('show-overlayer');

        const response = await api.get(`/painel/oportunidades-pipelines/listar-fases/${pipelineId}`);

        const fasesFormatadas = Array.isArray(response.data.fases)
          ? response.data.fases.map(f => ({ id: f.id, nome: f.value }))
          : [];

        this.fases[tipo] = fasesFormatadas;

        if (pipelineId) {
          this.todasFases[pipelineId] = fasesFormatadas;
        }
      } catch (e) {
        window.showToastDanger?.('body', 'Erro ao buscar fases da pipeline.');
        this.fases[tipo] = [];
      } finally {
        loader?.classList.remove('show-overlayer');
      }
    },
    capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    formatToolLabel(tool) {
      return tool
        .replace(/_/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
    },
    async getOpenAIModels() {
      try {
        const response = await api.get('/painel/ia/modelos');

        if (Array.isArray(response.data)) {
          this.modelosDisponiveis = response.data.sort((a, b) => a.id.localeCompare(b.id));
        } else {
          console.warn('Resposta inesperada:', response.data);
        }
      } catch (error) {
        window.showToastDanger?.('body', 'Erro ao buscar modelos da IA');
      }
    }
  }
}
</script>

<style scoped>
  .custom-form__card {
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  }
  .custom-modal-overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
  }

  .custom-modal {
    border-radius: 8px;
    padding: 20px;
    width: 80%;
    max-width: 700px;
  }

  body[data-theme="dark"] .custom-modal {
    background-color: black;
    color: white;
  }

  body:not([data-theme="dark"]) .custom-modal {
    background-color: white;
    color: black;
  }
</style>
